/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Meta_DescriptionInputs */

const en_svc_integration_meta_description = /** @type {(inputs: Svc_Integration_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We connect large language models to your CRM, email, documents and business software through their APIs: AI document processing, data extraction and automation.`)
};

const lv_svc_integration_meta_description = /** @type {(inputs: Svc_Integration_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Savienojam lielos valodas modeļus ar Jūsu CRM, e-pastu, dokumentiem un uzņēmuma programmatūru caur API: AI dokumentu apstrāde, datu ieguve un automatizācija.`)
};

/**
* | output |
* | --- |
* | "We connect large language models to your CRM, email, documents and business software through their APIs: AI document processing, data extraction and automation." |
*
* @param {Svc_Integration_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_meta_description = /** @type {((inputs?: Svc_Integration_Meta_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Meta_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_meta_description(inputs)
	return en_svc_integration_meta_description(inputs)
});